export const openSideMenu = function(){
    const wrapper = document.querySelector('#wrapper');
    const sideNav = document.querySelector('#side-nav');
    wrapper.classList.add('open');
    sideNav.classList.add('shadow');

}
export const closeSideMenu = function(){
    const wrapper = document.querySelector('#wrapper');
    const sideNav = document.querySelector('#side-nav');
    wrapper.classList.remove('open');
    sideNav.classList.remove('shadow');
}